import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Layout from "../Common/Layout";

export default function SelectQuoteFlow() {
  const navigate = useNavigate();
  const location = useLocation();
  const states = [
    { value: "", name: "Select a state" },
    { value: "Alabama", name: "Alabama" },
    { value: "Florida", name: "Florida" },
    { value: "Georgia", name: "Georgia" },
    { value: "Ohio", name: "Ohio" },
    { value: "South Carolina", name: "South Carolina" },
    { value: "Tennessee", name: "Tennessee" },
  ];
  // Pass client data from SearchClient if available
  const selectedClient = location.state?.selectedClient || null;
  const [selectedState, setSelectedState] = useState<string>(states[0].value);
  const [selectedStateError, setSelectedStateError] = useState<string>("");

  const generateGuid = () => {
    return crypto.randomUUID();
  };

  const handleSelectFlow = (flowType: "full" | "ancillary") => {
    setSelectedStateError("");
    if (!selectedClient && selectedState === "") {
      setSelectedStateError("Please select a state before proceeding.");
      return;
    }

    const transactionId = generateGuid();

    if (flowType === "ancillary") {
      localStorage.setItem("ancillaryFlow", "true");
      // Pass stepIndex for Quotes step
      navigate(`/insurance-workflow?transactionId=${transactionId}`, {
        state: {
          selectedClient,
          quoteFlow: flowType,
          stepIndex: 6,
          selectedState: selectedState,
        },
      });
    } else {
      localStorage.removeItem("ancillaryFlow");
      navigate(`/insurance-workflow?transactionId=${transactionId}`, {
        state: {
          selectedClient,
          quoteFlow: flowType,
          selectedState: selectedState,
        },
      });
    }
  };

  return (
    <Layout currentPage="Select Quote Flow">
      <div style={{ minHeight: "70vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f8fafc" }}>
        <div
          style={{
            width: "100%",
            maxWidth: 420,
            margin: "0 auto",
            background: "#fff",
            borderRadius: 16,
            boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
            padding: "2.5rem 2rem",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "2rem", fontWeight: 700, marginBottom: 8 }}>Select Quote Flow</h1>
          <p style={{ color: "#64748b", marginBottom: 24 }}>Choose which type of quote to start for this client.</p>
          {selectedClient && (
            <div style={{ marginBottom: 24, background: "#f1f5f9", borderRadius: 10, padding: "1rem 0.5rem" }}>
              <div>
                <div style={{ fontWeight: 600, color: "#475569", fontSize: 14, marginBottom: 2 }}>Selected Client</div>
                <div style={{ fontWeight: 500, fontSize: 16, marginBottom: 2 }}>
                  {selectedClient.firstName} {selectedClient.lastName}
                </div>
                <div style={{ color: "#64748b", fontSize: 13, marginBottom: 8 }}>
                  <span>{selectedClient.email}</span>
                  <span style={{ margin: "0 8px" }}>•</span>
                  <span>{selectedClient.phone}</span>
                </div>
              </div>
            </div>
          )}
           {!selectedClient && (
            <>
              <div className="state-dropdown-row">
                <div className="state-dropdown-group">
                  <label htmlFor="state-select" className="state-dropdown-label">
                    State
                  </label>
                  <select id="state-select" value={selectedState} onChange={(e) => { setSelectedState(e.target.value); setSelectedStateError(""); }} className="form-input compact-select">
                    {states.map((state) => (
                      <option key={state.value} value={state.value}>
                        {state.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="state-dropdown-row">
                {selectedStateError && <span className="error-message">{selectedStateError}</span>}
              </div>
            </>

          )}
          <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem", marginTop: 24 }}>
            <button
              className="btn btn-primary"
              style={{ fontSize: 18, padding: "0.75rem 0", borderRadius: 8 }}
              onClick={() => handleSelectFlow("full")}
            >
              Full Quote
            </button>
            <button
              className="btn btn-primary"
              style={{ fontSize: 18, padding: "0.75rem 0", borderRadius: 8 }}
              onClick={() => handleSelectFlow("ancillary")}
            >
              Ancillary Policies
            </button>
          </div>
         
        </div>
      </div>
      {/* Change Client button in form-actions area below the card, only if client is selected */}
      {/* {selectedClient && ( */}
        <div className="form-actions" style={{ display: "flex", justifyContent: "flex-start" }}>
          <button className="btn btn-secondary" style={{ marginLeft: 0 }} onClick={() => navigate("/search-client")}>
            Change Client
          </button>
        </div>
      {/* )} */}
    </Layout>
  );
}
